<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/engine/Thailand/tg.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器泰国工厂
                </div>
                <div class="manufacture-t2">
                    成立于2020年11月，占地42000平方米，拥有现代化厂房22000平方米，致力于成为东南亚地区领先的动力系统制造基地。
                    主要生产1.5L汽油机、2.0L汽油机、2.4L柴油机、3.0L柴油机。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
            <div class="page-t2">
                公司引进全球领先的制造与检测设备，确保产品精度与一致性。
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                工艺特点
                            </div>
                            <div class="destils">
                                配置38台高精度设备，以日系、欧系品牌为主，包括兰迪斯磨床、SMS淬火机、赫根赛特滚压机、霍美尔测量机等，产线采用U型布局，结合8节桁架机械手与自动辊道，实现全流程自动化上下料<br />
                                NTC小松内铣与车拉设备，采用随动铣削技术，确保曲轴关键尺寸的同轴度与圆度<br />
                                4台Landis磨床配备马波斯在线量仪与CBN砂轮，实现微米级精度磨削，保障工件稳定性<br />
                                ABB机器人去毛刺单元与高压清洗设备，全面提升产品清洁度与表面质量
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/Thailand/tg1-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器泰国工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/Thailand.html'
};

import { createApp } from 'vue';
import App from './Thailand.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./Thailand.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
